<template>
  <div>
    <a-card title="Detail Termin">
      <a-row :gutter="12">
        <a-form-model ref="diForm" :model="form" :rules="rules">
          <a-col :span="12">
            <a-form-model-item label="Termin Period" prop="periode">
              <a-month-picker placeholder="Select Termin Period" v-model="form.periode" format="YYYY-MM"/>
            </a-form-model-item>
            <a-form-model-item label="Termin Description" prop="work_name">
              <a-input v-model="form.work_name"></a-input>
            </a-form-model-item>
            <a-form-model-item label="Unit" prop="unit">
                  <a-auto-complete
                    :dataSource="initialSatuan"
                    placeholder="input here"
                    v-model="form.unit"
                    :filterOption="handleSatuan"
                  />
            </a-form-model-item>
            <a-form-model-item label="Quantity" prop="qty">
              <a-input-number
                :min="1"
                class="m-width-full m-text-align right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-model="form.qty"
                @change="handleChangeqtyPrice('add')"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="Unit price" prop="unit_price">
              <a-input-number
                :min="1"
                class="m-width-full m-text-align right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-model="form.unit_price"
                @change="handleChangeqtyPrice('add')"
              ></a-input-number>
              <div class="m-form-description-small"><b>Total : </b>{{formatCurrency(
                      dataProcessed.AccountDetail.project_currency,labelingQtyPrice)}}</div>
            </a-form-model-item>
            <a-form-model-item label="Remark" prop="remark">
              <a-input v-model="form.remark"></a-input>
            </a-form-model-item>
            <a-button
              @click="handleNew()"
              type="primary"
              icon="plus"
              class="m-width-full margin-top"
              >Add Detail</a-button
            >
          </a-col>
          <a-col :span="12">
            <a-card>
              <span slot="title">Invoice Detail</span>
              <a-table
                size="small"
                bordered
                :rowKey="mode == 'Create' ? 'id' : 'id_sc_dtl_invoice'"
                :columns="columns"
                :data-source="getDetailInvoice"
                :scroll="{ x: 500 }"
              >
                <span slot="no" slot-scope="item, record, index">
                  {{ index + 1 }}
                </span>
                <span slot="periode" slot-scope="item">
                  {{ moment(item.periode).format("YYYY-MM") }}
                </span>
                <span slot="value" slot-scope="item">
                  {{
                    formatCurrency(
                      dataProcessed.AccountDetail.project_currency,
                      item.value
                    )
                  }}
                </span>
                <span slot="quantity" slot-scope="item">
                  {{item.qty}} / {{item.unit}}
                </span>
                <span slot="unit_price" slot-scope="item">
                  {{formatCurrency(
                      dataProcessed.AccountDetail.project_currency,
                      item.unit_price
                    )}}
                </span>
                <span slot="remark" slot-scope="item">
                  {{item.remark !== 'null' ? item.remark : ''}}
                </span>
                <a-button-group slot="action" slot-scope="item, record">
                  <a-button
                    :disabled="record.edit_sts == 0"
                    @click="handleEdit(item)"
                    type="primary"
                    icon="edit"
                  ></a-button>
                  <a-button
                    :disabled="record.edit_sts == 0"
                    @click="handleRemove(item)"
                    type="danger"
                    icon="close"
                  ></a-button>
                </a-button-group>

                <template slot="footer" slot-scope="item">
                  <div class="footer-calc">
                    <a-row :gutter="8">
                      <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                        <span>Grand Total</span>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span="6">
                        <span class="m-text-align m-text-bold">
                          {{
                            formatCurrencyCode(
                              dataProcessed.AccountDetail.project_currency,
                              totalInvoiceDtl
                            )
                          }}
                        </span>
                      </a-col>
                    </a-row>
                  </div>
                </template>
              </a-table>
            </a-card>
          </a-col>
        </a-form-model>
      </a-row>
      <!-- <div class="action">
        
      </div> -->
    </a-card>

    <a-modal
      v-if="isEdit"
      :visible="isEdit"
      title="Change"
      centered
      @cancel="handleClose"
      @ok="handleSaveEdit"
    >
      <a-row :gutter="24">
        <a-form-model ref="formsEdit" :model="formEdit" :rules="rules">
          <a-col :span="24">
            <a-form-model-item label="Termin Period" prop="periode">
              <a-month-picker placeholder="Select Termin Period" v-model="formEdit.periode" format="YYYY-MM"/>
            </a-form-model-item>
            <a-form-model-item label="Termin Description" prop="work_name">
              <a-input v-model="formEdit.work_name"></a-input>
            </a-form-model-item>
            <a-form-model-item label="Unit" prop="unit">
                  <a-auto-complete
                    :dataSource="initialSatuan"
                    placeholder="input here"
                    v-model="formEdit.unit"
                    :filterOption="handleSatuan"
                  />
            </a-form-model-item>
            <a-form-model-item label="Quantity" prop="quantity">
              <a-input-number
                :min="1"
                class="m-width-full m-text-align right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-model="formEdit.qty"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="Unit price" prop="unit_price">
              <a-input-number
                :min="1"
                class="m-width-full m-text-align right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-model="formEdit.unit_price"
              ></a-input-number>
            </a-form-model-item>
            <a-form-model-item label="Remark" prop="remark">
              <a-input v-model="formEdit.remark"></a-input>
            </a-form-model-item>
          </a-col>
        </a-form-model>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import nanoid from "nanoid";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import _ from "lodash";

const backdate_validation = (rule, value, callback) => {
  if (!value.isValid()) {
    callback(new Error("Incorrect Format Date!"));
  } else if (value.isBefore(moment(), 'day')) {
    callback(new Error("Can't back date!"));
  } else {
    callback();
  }
};

export default {
  name: "invoice-detail",
  props: { dataProcessed: {}, mode: String },
  mixins: [CurrencyFormat],
  data() {
    const columns = [
      {
        title: "No",
        width: 50,
        key: "no",
        align: "center",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Termin Period",
        key: "periode",
        scopedSlots: { customRender: "periode" },
        width: 120,
      },
      {
        title: "Termin Description",
        key: "workname",
        dataIndex: "work_name",
        width: 250,
      },
      {
        title: "Quantity / Unit",
        key: "value",
        align: "right",
        width: 150,
        scopedSlots: { customRender: "quantity" },
      },
      {
        title: "Unit Price",
        key: "unit_price",
        align: "right",
        width: 150,
        scopedSlots: { customRender: "unit_price" },
      },
      {
        title: "Remark",
        key: "remark",
        width: 150,
        scopedSlots: { customRender: "remark" },
      },
      {
        title: "Action",
        width: 100,
        key: "action",
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ];
    return {
      form: {
        id: "",
        periode: "",
        work_name: "",
        remark: "",
        value: 1,
        unit:"",
        unit_price:"",
        qty: null,
      },
      formEdit: {},
      rules: {
        periode: {
          required: true,
          validator: backdate_validation,
          trigger: "change",
        },
        work_name: {
          required: true,
          message: "Please input work name",
          trigger: "blur",
        },
        value: {
          required: true,
          message: "Please input value",
          trigger: "blur",
        },
        remark: {
          required: true,
          message: "Please input remark",
          trigger: "blur",
        },
        unit: {
          required: true,
          message: "Please input unit",
          trigger: "blur",
        },
        unit_price: {
          required: true,
          message: "Please input unit price",
          trigger: "blur",
        },
        qty: {
          required: true,
          message: "Please input quantity",
          trigger: "blur",
        },
      },
      columns,
      isEdit: false,
      selectedItem: {},
      labelingQtyPrice:"",
    };
  },
  computed: {
    ...mapGetters([
      "getDetailInvoice",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getSatuan",
    ]),
    totalInvoiceDtl(){
      let totalValue = 0;
      this.getDetailInvoice.forEach((element) => {
        totalValue = totalValue + (element.qty*element.unit_price);
      });
      return totalValue;
    },
    initialSatuan() {
      let satuan = [];
      this.getSatuan.forEach((item) => {
        satuan.push(item["id"]);
      });
      return satuan;
    },
  },
  methods: {
    moment,
    handleNew() {
      this.$refs.diForm.validate((err, value) => {
        if (!err) {
          this.displayMessage("form-warning");
          return;
        }

        const newdt   = moment(this.form.periode).format('YYYY-MM');
        const existdt =  this.getDetailInvoice.filter(item=>moment(item.periode).format('YYYY-MM')==newdt);
        if(existdt.length>0){
          this.displayMessageValue("error-other", "Termin Period is Exist, please entry other period!");
          return;
        }
        
        if((this.totalInvoiceDtl+(this.form.qty*this.form.unit_price)) > this.dataProcessed.AccountDetail.project_value){
          this.displayMessageValue("error-other", "total value of detail termin grather than project value!");
          return;
        }

        if (this.mode == "Create") {
          this.form.id = nanoid();
        } else {
          this.form.id_sc_dtl_invoice = nanoid();
        }
        this.$store.dispatch("setDetailInvoice", this.form);
        Event.$emit("refreshInvoiceDetail");
        this.resetForm();
      });
    },
    resetForm() {
      this.$refs.diForm.resetFields();
      this.labelingQtyPrice = ""
    },
    handleEdit(item) {
      this.isEdit = true;
      this.formEdit = JSON.parse(JSON.stringify(item));
      this.formEdit.periode = moment(this.formEdit.periode)
      this.selectedItem = item;
    },
    handleClose() {
      this.isEdit = false;
      this.formEdit = {};
    },
    handleRemove(item) {
      this.$store.dispatch("removeDetailInvoice", item);
      Event.$emit("refreshInvoiceDetail");
    },
    handleSaveEdit() {
      this.$refs.formsEdit.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let idx = null;
        let idxselected = null;
        let existdt = [];
        const newdt   = moment(this.formEdit.periode).format('YYYY-MM');

        if (this.mode=="Create"){
          idx = this.formEdit.id;
          idxselected = this.getDetailInvoice.findIndex((data) => data.id == idx);
          existdt =  this.getDetailInvoice.filter(item=>moment(item.periode).format('YYYY-MM')==newdt && item.id!=idx);
        }else{
          idx = this.formEdit.id_sc_dtl_invoice;
          idxselected = this.getDetailInvoice.findIndex((data) => data.id_sc_dtl_invoice == idx);
          existdt =  this.getDetailInvoice.filter(item=>moment(item.periode).format('YYYY-MM')==newdt && item.id_sc_dtl_invoice!=idx);
        }
        let valselected = this.getDetailInvoice[idxselected];
        if(((this.totalInvoiceDtl-(valselected.qty*valselected.unit_price))+(this.formEdit.qty*this.formEdit.unit_price)) >
            this.dataProcessed.AccountDetail.project_value){
            this.displayMessageValue("error-other", "total value of detail termin grather than project value!");
          return;
        }

        if(existdt.length>0){
          this.displayMessageValue("error-other", "Termin Period is Exist, please entry other period!");
          return;
        }

        this.$store
          .dispatch("editDetailInvoice", {
            value: this.formEdit,
            mode: this.mode,
          })
          .then((res) => {
            this.isEdit = false;
            this.selectedItem = {};
            this.displayMessage("success-edit");
          });
      })
    },
    handleRef() {
      if (this.getDetailInvoice.length === 0) {
        this.displayMessageValue("basic-error", "Detail Invoice cannot empty!");
        return;
      }else if (this.totalInvoiceDtl!=this.dataProcessed.AccountDetail.project_value){
        this.displayMessageValue("basic-error", "total value of detail termin grather than project value!");
        return; 
      }
      Event.$emit("dataProcessed", this.getDetailInvoice);
    },
    handleSatuan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleChangeqtyPrice(val){
      if (val=="add"){
        this.labelingQtyPrice = 
          Number(this.form.qty=="" ? 0 : this.form.qty) 
          * Number(this.form.unit_price=="" ? 0 : this.form.unit_price);
      }else{
        this.labelingQtyPrice = 
          Number(this.formEdit.qty=="" ? 0 : this.formEdit.qty) 
          * Number(this.formEdit.unit_price=="" ? 0 : this.formEdit.unit_price);
      }
    }
  },
};
</script>

<style lang="less" scoped>
.action {
  border-top: 1px solid darken(white, 10);
  height: 50px;
  margin-top: @margin;
  padding: @padding 0;
}
</style>
